import * as Yup from 'yup'

import { regExp } from 'src/shared/forms'

export const formValidationSchema = Yup.object().shape({
  name: Yup.string()
    .min(2, 'Имя и фамилия указны не полностью')
    .max(50, 'Мы не знаем таких длинных имен')
    .required('Поле обязательно к заполнению'),
  phone: Yup.string()
    .matches(regExp.maskPhone, 'Некорректный номер телефона')
    .required('Поле обязательно к заполнению'),
  email: Yup.string()
    .matches(regExp.email, 'Некорректный e-mail')
    .required('Поле обязательно к заполнению'),
  telegram: Yup.string().required('Поле обязательно к заполнению'),
  vacancy: Yup.string().required('Выберите одно из направлений'),
  friendPhone: Yup.string()
    .matches(regExp.maskPhone, 'Некорректный номер телефона')
    .required('Поле обязательно к заполнению'),
  message: Yup.string().max(
    5000,
    'Длина сообщения не должна превышать 5000 знаков'
  ),
})
